import type { NamedExoticComponent } from 'react';

import { nest } from 'recompact';

import type { ErrorBoundaryProps } from 'src/app/components/Error/Boundary';
import { ErrorBoundary } from 'src/app/components/Error/Boundary';

/**
 * Wraps BaseComponent in a React 16+ ErrorBoundary
 *
 * <ErrorBoundary>
 *   <BaseComponent />
 * </ErrorBoundary>
 */
export const errorBoundary = (BaseComponent: NamedExoticComponent) => {
  const componentName = BaseComponent?.displayName ?? 'UnknownComponent';

  return nest(
    (props: ErrorBoundaryProps) => <ErrorBoundary {...props} errorSourceComponentName={componentName} />,
    BaseComponent
  );
};
